import { Link } from '@/app/router';
import { ArrowRightIcon, GridIcon } from '@/lib/icons';

/**
 * The door from the lifter page to the CRM page.
 *
 * Deliberately small and subordinate: one line on the platform plan §3, a link
 * out, and no CRM pricing anywhere near the lifter page. The CRM is sold to
 * coaches and gyms, so the lifter home page keeps its own proposition — this
 * band is an exit, not a pitch.
 */
export function CrmDoor() {
  return (
    <section id="coaches-gyms" data-testid="crm-door" className="border-b border-hairline bg-page-subtle py-10">
      <div className="mx-auto flex max-w-[1200px] 2xl:max-w-[1440px] min-[1920px]:max-w-[1720px] flex-col gap-4 px-4 sm:px-6 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex items-start gap-4">
          <span className="mt-[2px] inline-flex h-9 w-9 shrink-0 items-center justify-center border border-hairline text-accent">
            <GridIcon className="text-base" />
          </span>
          <div className="flex flex-col gap-1">
            <h2 className="font-display text-[16px] font-black uppercase tracking-[-0.01em] text-ink">
              For coaches &amp; gyms
            </h2>
            <p className="max-w-[76ch] text-[13px] leading-relaxed text-ink-muted">
              Running clients from spreadsheets and a calendar? Lift2Fit for coaches and gyms is a separate
              coaching workspace — roster, programmes, bookings and payments, with AI assistance across every
              client. Your clients get a full lifter app of their own.
            </p>
          </div>
        </div>

        <Link
          to="/for-coaches"
          data-testid="crm-door-link"
          className="inline-flex h-11 shrink-0 items-center justify-center gap-2 border border-hairline px-5 text-[12px] font-bold uppercase tracking-[0.08em] text-ink transition-colors duration-150 hover:border-accent hover:text-accent"
        >
          For coaches &amp; gyms <ArrowRightIcon className="text-sm" />
        </Link>
      </div>
    </section>
  );
}
